// extracted by mini-css-extract-plugin
export default {"ingr":"MyDishes_ingr__BF0QY","icons":"MyDishes_icons__TxOoe","edit":"MyDishes_edit__CzA6A","highlight":"MyDishes_highlight__s-F6g"};